import React, { Fragment, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import Snackbar, { openSnackbar } from '../utils/Snackbar';
import axios from '../../axios/axios';
import * as actionTypes from '../../store/action';
import AsyncentricLogo from '../../images/asyncentric.png';

const styles = theme => ({
    root: {

    },
    leftContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: "#000000",
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            height: '50vh'
        }
    },
    rightContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            height: '50vh'
        }
    },
    logoImage: {
        width: '300px',
        height: '300px',
        margin: '10px 0',
        [theme.breakpoints.down('sm')]: {
            width: '200px',
            height: '200px',
        }
    },
    logoText: {
        color: '#FFFFFF',
        fontSize: '50px',
        fontWeight: '700',
        [theme.breakpoints.down('sm')]: {
            fontSize: '40px',
        },
        '&::after': {
            display: 'block',
            width: '4em',
            height: '3px',
            background: '#51e3d4',
            content: '" "',
            margin: '5px auto',
            borderRadius: '2px'
        }
    },
    headingText: {
        margin: '10px 0',
        fontSize: '30px',
        fontWeight: '400',
        [theme.breakpoints.down('sm')]: {
            fontSize: '25px',
        },
        '&::after': {
            display: 'block',
            width: '2em',
            height: '3px',
            backgroundColor: '#ff9933',
            content: '" "',
            margin: '2px auto',
            borderRadius: '2px'
        }
    },
    textField: {
        width: '40%',
        margin: '10px 0',
        [theme.breakpoints.down('sm')]: {
            width: '70%',
        }
    },
    button: {
        margin: '10px 0',
        color: '#FFFFFF',
        backgroundColor: '#ff9933',
        '&:hover': {
            color: '#FFFFFF',
            backgroundColor: '#e67300'
        }
    }
});

const Login = (props) => {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loader, setLoader] = useState(false);

    const inputChangeHandler = (event) => {
        if (event.target.name === 'username') {
            setUsername(event.target.value);
        } else {
            setPassword(event.target.value);
        }
    }

    const authenticate = (e) => {
        e.preventDefault();
        if (username === '') {
            openSnackbar({ message: "Please enter username", variant: "info" });
        } else if (password === '') {
            openSnackbar({ message: "Please enter password", variant: "info" });
        } else {
            setLoader(true);
            axios.post('admin/login', { username: username, password: password })
                .then(result => {
                    setLoader(false);
                    if (result.status === 200) {
                        if (result.data.success) {
                            props.history.push("/admin/dashboard");
                            props.saveToken(result.data.token);
                        } else {
                            openSnackbar({ message: result.data.msg, variant: "error" });
                        }
                    } else {
                        openSnackbar({ message: result.data.msg, variant: "error" });
                    }
                }).catch(exception => {
                    setLoader(false);
                    openSnackbar({ message: "Something went wrong", variant: "error" });
                });
        }
    }

    const { classes } = props;
    return (
        <Fragment>
            <section className={classes.root}>
                <Snackbar />
                <Grid container>
                    <Grid item xs={12} sm={12} lg={6}>
                        <div className={classes.leftContainer}>
                            <div>
                                <img src={AsyncentricLogo} alt="Asyncentric Logo" className={classes.logoImage}></img>
                                <Typography variant="h5">
                                    <span className={classes.logoText}>𝐀𝐒𝐘𝐍𝐂𝐄𝐍𝐓𝐑𝐈𝐂</span>
                                </Typography>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                        <div className={classes.rightContainer}>
                            <Typography variant="h5" className={classes.headingText}>Login</Typography>
                            <form noValidate autoComplete="off" onSubmit={authenticate}>
                                <TextField
                                    label="Username"
                                    name="username"
                                    type="text"
                                    variant="outlined"
                                    className={classes.textField}
                                    value={username}
                                    onChange={inputChangeHandler}
                                />
                                <br />
                                <TextField
                                    label="Password"
                                    name="password"
                                    type="password"
                                    variant="outlined"
                                    className={classes.textField}
                                    value={password}
                                    onChange={inputChangeHandler}
                                />
                                <br />
                                {
                                    loader ?
                                        <CircularProgress className={classes.progress} color="secondary" /> :
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            type="submit"
                                            className={classes.button}>
                                            Submit</Button>
                                }
                            </form>
                        </div>
                    </Grid>
                </Grid>
            </section>
        </Fragment>
    );
}

Login.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = dispatch => {
    return {
        saveToken: (token) => dispatch({ type: actionTypes.TOKEN, token: token }),
    }
}

export default connect(null, mapDispatchToProps)(withStyles(styles)(Login));